(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-notification"] && !Shopify.designMode) return;
  try {
    (() => {
    const mutationEvent = 'md:cozy-cart-mutated';
    const giftMarker = '_cozy_sunday_gift';
    const giftMarkerValue = '2026-09-13';

    if (!document.querySelector('cozy-sunday-gift')) return;

    if (!window.__mdCozySundayFetchWrapped) {
      const originalFetch = window.fetch;

      window.fetch = function (...args) {
        return originalFetch.apply(this, args).then((response) => {
          try {
            const input = args[0];
            const options = args[1] || {};
            const rawUrl = typeof input === 'string' ? input : input.url;
            const inputMethod = typeof input === 'string' ? '' : input.method;
            const method = String(options.method || inputMethod || 'GET').toUpperCase();
            const path = new URL(rawUrl, window.location.origin).pathname;

            if (
              method !== 'GET' &&
              /\/cart\/(add|change|update|clear)(\.js)?$/.test(path)
            ) {
              window.setTimeout(() => window.dispatchEvent(new CustomEvent(mutationEvent)), 0);
            }
          } catch (error) {
            return response;
          }

          return response;
        });
      };

      window.__mdCozySundayFetchWrapped = true;
    }

    class CozySundayGift extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        const drawer = document.querySelector('cart-notification');
        const scrollArea = drawer && drawer.querySelector('.md-cart-scroll');
        const regularProgress = scrollArea && scrollArea.querySelector('.md-cart-progress');
        const template = this.querySelector('[data-md-cozy-template]');

        if (!drawer || !scrollArea || !regularProgress || !template) return;

        const fragment = template.content.cloneNode(true);
        this.panel = fragment.querySelector('[data-md-cozy-panel]');
        regularProgress.before(fragment);

        this.initialized = true;
        this.drawer = drawer;
        this.itemsContainer = drawer.querySelector('[data-md-cart-items]');
        this.thresholdCents = Number(this.dataset.thresholdCents || 4900);
        this.giftProductId = String(this.dataset.giftProductId || '');
        this.giftVariantId = Number(this.dataset.giftVariantId || 0);
        this.giftPriceCents = Number(this.dataset.giftPriceCents || 0);
        this.giftAvailable = this.dataset.giftAvailable === 'true';
        this.startsAt = Date.parse(this.dataset.startsAt || '');
        this.endsAt = Date.parse(this.dataset.endsAt || '');
        this.discountTitle = String(this.dataset.discountTitle || '');
        this.qualifyingProductIds = new Set(
          String(this.dataset.qualifyingProductIds || '')
            .split(',')
            .map((value) => value.trim())
            .filter(Boolean)
        );
        this.locked = false;
        this.rerun = false;
        this.pending = false;
        this.failed = false;
        this.soldOut = false;
        this.boundSchedule = () => this.schedule(130);
        this.boundSubmit = (event) => {
          if (!this.pending && !this.locked) return;
          event.preventDefault();
          this.schedule(0);
        };

        window.addEventListener(mutationEvent, this.boundSchedule);
        window.addEventListener('pageshow', this.boundSchedule);
        this.drawer.addEventListener('submit', this.boundSubmit, true);

        if (this.itemsContainer) {
          this.observer = new MutationObserver(this.boundSchedule);
          this.observer.observe(this.itemsContainer, { childList: true });
        }

        if (Number.isFinite(this.endsAt)) {
          const expiryDelay = this.endsAt - Date.now() + 1000;
          if (expiryDelay > 0) {
            this.expiryTimer = window.setTimeout(
              () => this.schedule(0),
              Math.min(expiryDelay, 2147483647)
            );
          }
        }

        this.schedule(0);
      }

      disconnectedCallback() {
        if (!this.initialized) return;
        window.removeEventListener(mutationEvent, this.boundSchedule);
        window.removeEventListener('pageshow', this.boundSchedule);
        this.drawer.removeEventListener('submit', this.boundSubmit, true);
        if (this.observer) this.observer.disconnect();
        window.clearTimeout(this.scheduleTimer);
        window.clearTimeout(this.expiryTimer);
        window.clearTimeout(this.noticeTimer);
      }

      schedule(delay = 130) {
        this.pending = true;
        this.setCheckoutPending(true);
        window.clearTimeout(this.scheduleTimer);
        this.scheduleTimer = window.setTimeout(() => this.reconcile(), delay);
      }

      async reconcile() {
        if (!this.panel) return;

        if (this.locked) {
          this.rerun = true;
          return;
        }

        this.locked = true;
        this.pending = false;
        this.rerun = false;

        try {
          let cart = await this.getCart();
          const now = Date.now();
          const activeTime =
            Number.isFinite(this.startsAt) &&
            Number.isFinite(this.endsAt) &&
            now >= this.startsAt &&
            now <= this.endsAt;
          const isEur = String(cart.currency || '').toUpperCase() === 'EUR';

          if (!activeTime || !isEur) {
            if (this.markedGiftLines(cart).length > 0) {
              cart = await this.removeMarkedGiftLines(cart);
              this.syncDrawer(cart);
            }
            document.documentElement.classList.remove('md-cozy-active');
            this.panel.hidden = true;
            return;
          }

          this.panel.hidden = false;

          if (!this.giftAvailable || this.soldOut) {
            if (this.markedGiftLines(cart).length > 0) {
              cart = await this.removeMarkedGiftLines(cart);
              this.syncDrawer(cart);
            }
            document.documentElement.classList.remove('md-cozy-active');
            this.showState('unavailable', cart, 0);
            return;
          }

          document.documentElement.classList.add('md-cozy-active');
          const eligibleCents = this.eligibleSubtotal(cart);
          let markedLines = this.markedGiftLines(cart);

          if (eligibleCents < this.thresholdCents) {
            this.failed = false;
            const hadGift = markedLines.length > 0;
            if (hadGift) {
              cart = await this.removeMarkedGiftLines(cart);
              this.syncDrawer(cart);
            }
            this.showState('progress', cart, eligibleCents);
            if (hadGift) this.showRemovalNotice();
            return;
          }

          if (markedLines.length > 0) {
            const markedQuantity = markedLines.reduce(
              (total, item) => total + Number(item.quantity || 0),
              0
            );
            const needsNormalization = markedLines.length > 1 || markedQuantity !== 1;

            if (needsNormalization) {
              cart = await this.normalizeMarkedGift(cart);
              markedLines = this.markedGiftLines(cart);
              this.syncDrawer(cart);
            }

            if (await this.waitForCozyDiscount(cart)) {
              cart = await this.getCart();
              this.showState('added', cart, eligibleCents);
              this.decorateGiftLine(cart);
              return;
            }

            cart = await this.removeMarkedGiftLines(await this.getCart());
            this.syncDrawer(cart);
            this.failed = true;
            this.showState('error', cart, eligibleCents);
            return;
          }

          if (this.failed) {
            this.showState('error', cart, eligibleCents);
            return;
          }

          this.showState('adding', cart, eligibleCents);

          try {
            await this.postJson(this.dataset.cartAddUrl, {
              items: [
                {
                  id: this.giftVariantId,
                  quantity: 1,
                  properties: {
                    [giftMarker]: giftMarkerValue
                  }
                }
              ]
            });
          } catch (error) {
            if (error.status === 422) this.soldOut = true;
            else this.failed = true;
            this.showState(error.status === 422 ? 'unavailable' : 'error', cart, eligibleCents);
            return;
          }

          cart = await this.getCart();

          if (!(await this.waitForCozyDiscount(cart))) {
            cart = await this.removeMarkedGiftLines(await this.getCart());
            this.syncDrawer(cart);
            this.failed = true;
            this.showState('error', cart, eligibleCents);
            return;
          }

          cart = await this.normalizeMarkedGift(await this.getCart());
          this.syncDrawer(cart);
          this.showState('added', cart, eligibleCents);
          this.decorateGiftLine(cart);
        } catch (error) {
          this.failed = true;
          this.showState('error', null, 0);
        } finally {
          this.locked = false;
          if (this.rerun) this.schedule(140);
          else this.setCheckoutPending(false);
        }
      }

      async getCart() {
        const response = await fetch(this.dataset.cartJsonUrl, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        });

        if (!response.ok) {
          const error = new Error('Cart could not be loaded');
          error.status = response.status;
          throw error;
        }

        return response.json();
      }

      async postJson(url, body) {
        const response = await fetch(url, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify(body)
        });

        if (!response.ok) {
          const error = new Error('Cart could not be updated');
          error.status = response.status;
          throw error;
        }

        return response.json();
      }

      markedGiftLines(cart) {
        return (cart.items || []).filter((item) => {
          return (
            String(item.product_id) === this.giftProductId &&
            item.properties &&
            item.properties[giftMarker] === giftMarkerValue
          );
        });
      }

      eligibleSubtotal(cart) {
        return (cart.items || []).reduce((total, item) => {
          if (!this.qualifyingProductIds.has(String(item.product_id))) return total;
          if (item.properties && item.properties[giftMarker] === giftMarkerValue) return total;
          return total + Number(item.final_line_price || 0);
        }, 0);
      }

      cozyDiscountAmount(cart) {
        return (cart.items || [])
          .filter((item) => String(item.product_id) === this.giftProductId)
          .reduce((total, item) => {
            const allocations = item.line_level_discount_allocations || [];
            return total + allocations.reduce((sum, allocation) => {
              const application = allocation.discount_application || {};
              if (String(application.title || '') !== this.discountTitle) return sum;
              return sum + Number(allocation.amount || 0);
            }, 0);
          }, 0);
      }

      requiredGiftDiscount(cart) {
        return (cart.items || [])
          .filter((item) => String(item.product_id) === this.giftProductId)
          .reduce((lowest, item) => {
            const unitPrice = Number(item.original_price || item.price || 0);
            if (unitPrice <= 0) return lowest;
            return lowest === 0 ? unitPrice : Math.min(lowest, unitPrice);
          }, 0) || this.giftPriceCents;
      }

      hasCozyDiscount(cart) {
        const required = this.requiredGiftDiscount(cart);
        return required > 0 && this.cozyDiscountAmount(cart) >= required;
      }

      async waitForCozyDiscount(initialCart) {
        let cart = initialCart;
        if (this.hasCozyDiscount(cart)) return true;

        for (let attempt = 0; attempt < 3; attempt += 1) {
          await this.wait(180 + attempt * 100);
          cart = await this.getCart();
          if (this.hasCozyDiscount(cart)) return true;
        }

        return false;
      }

      async removeMarkedGiftLines(cart) {
        let currentCart = cart;

        for (let index = 0; index < 10; index += 1) {
          const line = this.markedGiftLines(currentCart)[0];
          if (!line) break;
          currentCart = await this.postJson(this.dataset.cartChangeUrl, {
            id: line.key,
            quantity: 0
          });
        }

        return currentCart;
      }

      async normalizeMarkedGift(cart) {
        let currentCart = cart;
        let lines = this.markedGiftLines(currentCart);

        if (lines.length > 0 && Number(lines[0].quantity || 0) !== 1) {
          currentCart = await this.postJson(this.dataset.cartChangeUrl, {
            id: lines[0].key,
            quantity: 1
          });
        }

        for (let index = 0; index < 9; index += 1) {
          lines = this.markedGiftLines(currentCart);
          if (lines.length <= 1) break;
          currentCart = await this.postJson(this.dataset.cartChangeUrl, {
            id: lines[1].key,
            quantity: 0
          });
        }

        return currentCart;
      }

      syncDrawer(cart) {
        if (this.drawer && typeof this.drawer.renderCart === 'function') {
          this.drawer.renderCart(cart);
        }
        this.decorateGiftLine(cart);
      }

      setCheckoutPending(pending) {
        const button = this.drawer && this.drawer.querySelector('button[name="checkout"]');
        if (!button) return;
        button.disabled = Boolean(pending);
        button.setAttribute('aria-busy', pending ? 'true' : 'false');
      }

      showState(state, cart, eligibleCents) {
        if (!this.panel) return;

        const safeEligible = Math.max(0, Number(eligibleCents || 0));
        const progress = Math.min(100, (safeEligible / this.thresholdCents) * 100);
        const remaining = Math.max(0, this.thresholdCents - safeEligible);
        const currency = cart && cart.currency ? cart.currency : 'EUR';

        this.panel.hidden = false;
        this.panel.dataset.state = state;
        this.panel.querySelectorAll('[data-md-cozy-state]').forEach((node) => {
          node.hidden = node.dataset.mdCozyState !== state;
        });

        const remainingNode = this.panel.querySelector('[data-md-cozy-remaining]');
        if (remainingNode) remainingNode.textContent = this.formatMoney(remaining, currency);

        const progressNode = this.panel.querySelector('[data-md-cozy-progress]');
        const fillNode = this.panel.querySelector('[data-md-cozy-progress-fill]');

        if (progressNode) {
          progressNode.setAttribute(
            'aria-valuenow',
            String(Math.min(this.thresholdCents, safeEligible) / 100)
          );
          progressNode.setAttribute(
            'aria-valuetext',
            this.formatMoney(safeEligible, currency) +
              ' ' +
              this.dataset.copyOf +
              ' ' +
              this.formatMoney(this.thresholdCents, currency)
          );
        }

        if (fillNode) fillNode.style.width = progress + '%';
      }

      showRemovalNotice() {
        const notice = this.panel && this.panel.querySelector('[data-md-cozy-notice]');
        if (!notice) return;
        notice.hidden = false;
        window.clearTimeout(this.noticeTimer);
        this.noticeTimer = window.setTimeout(() => {
          notice.hidden = true;
        }, 4500);
      }

      decorateGiftLine(cart) {
        if (!this.itemsContainer || !cart) return;

        const marked = this.markedGiftLines(cart)[0];
        if (!marked) return;

        const index = (cart.items || []).findIndex((item) => item.key === marked.key);
        const articles = this.itemsContainer.querySelectorAll('.md-cart-item');
        const article = index >= 0 ? articles[index] : null;
        if (!article) return;

        article.classList.add('md-cart-item--cozy');

        const content = article.querySelector('.md-cart-item__content');
        const title = article.querySelector('.md-cart-item__title');

        if (content && title && !content.querySelector('.md-cozy-line-badge')) {
          const badge = document.createElement('span');
          badge.className = 'md-cozy-line-badge';
          badge.textContent = this.dataset.copyGiftBadge;
          content.insertBefore(badge, title);
        }

        const price = article.querySelector('.md-cart-item__price');
        if (price && this.hasCozyDiscount(cart)) {
          price.textContent = this.dataset.copyFree;
        }
      }

      formatMoney(cents, currency) {
        if (this.drawer && typeof this.drawer.formatMoney === 'function') {
          return this.drawer.formatMoney(cents, currency);
        }

        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
            style: 'currency',
            currency: currency || 'EUR'
          }).format((Number(cents) || 0) / 100);
        } catch (error) {
          return ((Number(cents) || 0) / 100).toFixed(2).replace('.', ',') + ' €';
        }
      }

      wait(milliseconds) {
        return new Promise((resolve) => window.setTimeout(resolve, milliseconds));
      }
    }

    if (!customElements.get('cozy-sunday-gift')) {
      customElements.define('cozy-sunday-gift', CozySundayGift);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
